import { Section } from "Components/atoms/Section";
import { Accordion } from "Components/organisms/Accordion";
import { faqData } from "shared/config/faqData";
import {
  AccordionHeaderWrapper,
  AccordionSectionSubtitle,
  AccordionSectionTitle,
} from "./styles";
import { AdBannerFooterContainerDesktop } from "Components/molecules/AdBannerFooter/Desktop";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
import { AdBannerContainer } from "Components/molecules/AdBanner";
import { type FaqAds, HOME_FAQ_ADS } from "shared/config/adSlots";

type AccordionInfoTemplateProps = {
  /** Centraliza título e subtítulo (padrão: alinhados à esquerda, como na home). */
  centered?: boolean;
  /** Anúncios exibidos abaixo do FAQ (padrão: os da home). */
  ads?: FaqAds;
  /**
   * A partir de qual breakpoint o banner desktop (970x90) substitui os de
   * celular. O padrão `xxl` (1536px) é o da home; `xl` (1280px) serve para
   * páginas em que o conteúdo já comporta 970px nessa largura.
   */
  desktopAdFrom?: "xl" | "xxl";
};

/**
 * Componente AccordionInfoTemplate
 *
 * Exibe uma seção de FAQ com cabeçalho, uma lista de perguntas frequentes e
 * os anúncios abaixo dela.
 *
 * @param centered - Centraliza o cabeçalho (usado na página de alertas).
 * @param ads - Slots do GAM; por padrão os da home.
 * @param desktopAdFrom - Breakpoint mínimo do banner desktop.
 */
export const AccordionInfoTemplate = ({
  centered = false,
  ads = HOME_FAQ_ADS,
  desktopAdFrom = "xxl",
}: AccordionInfoTemplateProps) => {
  const breakpoint = useBreakpoint();

  /* Derivado direto do breakpoint, sem estado: com `useState(false)` + efeito,
     o primeiro render em tela pequena montava o banner desktop e o GPT chegava
     a definir e exibir o slot 970x90 antes de ele sumir. */
  const isMobile =
    desktopAdFrom === "xl"
      ? breakpoint !== "xl" && breakpoint !== "xxl"
      : breakpoint !== "xxl";

  const accordionData = faqData;

  return (
    <Section maxWidth={1400} backgroundColor="transparent">
      {/* Cabeçalho da seção */}
      <AccordionHeaderWrapper $centered={centered}>
        <AccordionSectionTitle $centered={centered}>
          Viaje mais pelo Brasil e pelo mundo
        </AccordionSectionTitle>

        <AccordionSectionSubtitle $centered={centered}>
          Como encontrar passagens aéreas baratas com o Voopter
        </AccordionSectionSubtitle>
      </AccordionHeaderWrapper>

      {/* Acordeão com os dados do FAQ */}
      <Accordion items={accordionData} />

      {isMobile ? (
        <>
          {ads.mobile.map((slot) => (
            <AdBannerContainer
              key={slot.slotId}
              slotId={slot.slotId}
              adUnit={slot.adUnit}
              sizes={slot.sizes}
              marginTop={30}
            />
          ))}
        </>
      ) : (
        <AdBannerFooterContainerDesktop
          slotId={ads.desktop.slotId}
          adUnit={ads.desktop.adUnit}
          width={ads.desktop.sizes[0][0]}
          height={ads.desktop.sizes[0][1]}
        />
      )}
    </Section>
  );
};
